import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupyGantPrzerwa(drop_grupa_global_id,nowy_koniec,refreshGantAll) {

// id = procesor id

  axios.get(IP + "zmienCzasTrwaniaGrupyPrzerwa/"+drop_grupa_global_id+"/"+nowy_koniec)
    .then((res) => {
    // console.log("procesor " +res.data[0].mcr)
    // fechparametryTechnologii
    refreshGantAll()

    });
}
